// Atribuição de anúncio pra mandar pro checkout: fbc/fbp dos cookies que o
// tracker seta (_fbc/_fbp) + UTMs first-touch do cookie `_trakd_utm` (persistido
// pelo tracker, sobrevive à navegação). Fallback pra UTM da URL atual. Vai pro
// metadata do Stripe e o parser (apps/api) atribui a venda ao anúncio na Meta.
//
// Compartilhado entre o CTA de /precos (checkout antigo) e a ilha Stripe
// Elements de /pay/[tier].

export const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const;

export function readCookie(name: string): string | undefined {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m?.[1] ? decodeURIComponent(m[1]) : undefined;
}

export function gatherAttribution(): Record<string, string> {
  const attr: Record<string, string> = {};
  const fbc = readCookie('_fbc');
  const fbp = readCookie('_fbp');
  if (fbc) attr['fbc'] = fbc;
  if (fbp) attr['fbp'] = fbp;

  // UTMs first-touch persistidas pelo tracker (cookie `_trakd_utm`).
  let fromCookie = false;
  const persisted = readCookie('_trakd_utm');
  if (persisted) {
    try {
      const utms = JSON.parse(persisted) as Record<string, unknown>;
      for (const k of UTM_KEYS) {
        if (typeof utms[k] === 'string') attr[k] = utms[k] as string;
      }
      fromCookie = true;
    } catch {
      /* cookie inválido: cai pro fallback da URL */
    }
  }
  if (!fromCookie) {
    const params = new URLSearchParams(window.location.search);
    for (const k of UTM_KEYS) {
      const v = params.get(k);
      if (v) attr[k] = v;
    }
  }
  return attr;
}
